import { useEffect } from "react";

const useBodyClass = (classNames: Array<string>, ...watch: Array<any>): void => {

  useEffect(() => {
    document.body.classList.value = '';
    classNames.forEach((className: string) => {
      document.body.classList.add(className);
    });
  }, []);

  useEffect(() => {
    if (watch) {
      document.body.classList.value = '';
      classNames.forEach((className: string) => {
        document.body.classList.add(className);
      });
    }
  }, watch);

}

export default useBodyClass;